import React, { useState } from 'react';
import { mapDivEnterToClick } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import { UIProperties } from '../UIProperties';

import './VortexJobAidUI.css';

interface ImageData {
	img: string;
	altData: string;
	clickedAlt: string;
	initialWidth: string;
}
var mouseStartPos: any = null;
var initialMouseOffset = {
	top: 0,
	left: 0
};
const VortexJobAidUI = (props: UIProperties<VortexJobAidUIConfig>) => {
	const [currentlySelectedImageIndx, setCurrentlySelectedImageIndx] = useState(0);
	const [currentMouseOffet, setCurrentMouseOffet] = useState(initialMouseOffset);
	const [isDragging, setIsDragging] = useState(false);
	const [currentZoomValue, setCurrentZoomValue] = useState(1);

	const zoomIncrement = 0.25;
	const minZoomValue = 1;
	const maxZoomValue = 1.5;
	const imageData: ImageData[] = [ 
		{
			img: './assets/images/vortex-job-aid/Vortex_Optimization_Job_Aid.jpg',
			altData: 'Select to see the Vortex Optimization Strategies Image',
			clickedAlt: 'BVM column includes: Sniffing Position, Jaw thrust, Bed height. Dentures in. Laryngeal manipulation (includes ease cricoid). 2 Hands, Cuff Inflation, Thumb Grip. OPA, NPA. FM. Suction, O2 Flush / Increase O2 Flow. Consider Adequacy Anaesthesia / M. Relaxation. SGA column includes: Sniffing Position, Jaw thrust, Bed height. Laryngeal manipulation (includes ease cricoid). Twist, Cuff inflation. Fingers, Introducer / Laryngoscope, Bougie. SGA. Suction Foreign Materials. Consider Adequacy Anaesthesia / M. Relaxation. ETT column includes: Sniffing Position, Jaw thrust, Bed height. Dentures out. Laryngeal manipulation (includes ease cricoid). Lift Epiglottis, Rotate. Stylette, Bougie, Magill Forceps. Blade / Handle / VL, ETT. Suction Foreign Material. Consider Adequacy Anaesthesia / M. Relaxation.',
			initialWidth: '1054px'
		},
		{
			img: './assets/images/vortex-job-aid/VortexCognitiveAidUpdated.jpg',
			altData: 'Select to see Image of The Vortex',
			clickedAlt: 'The Vortex Emergency Surgical Airway includes Face Mask, Supraglottic Airway, and Endotracheal Tube. Maximum three tries at each non-surgical airway technique. At least one try should be had by most experienced available clinician. For each NSA technique consider: 1. Manipulations: Head and Neck, Larynx, and Current Airway Device. 2. Adjuncts. 3. Change Size / Type. 4. Suction. 5. Muscle Tone.',
			initialWidth: '973px'
		}
	]

	const onNextOrBackClicked = (newImageIndx: number) => {
		if(newImageIndx < 0) {
			newImageIndx = imageData.length - 1;
		}
		if(newImageIndx >= imageData.length) {
			newImageIndx = 0;
		}
		onZoomClicked(minZoomValue);
		setCurrentMouseOffet(initialMouseOffset);
		setIsDragging(false);
		setCurrentlySelectedImageIndx(newImageIndx);
	}

	const onZoomClicked = (zoomValue: number) => {
		if(zoomValue > maxZoomValue) {
			zoomValue = maxZoomValue;
		}

		if(zoomValue < minZoomValue) {
			zoomValue = minZoomValue;
		}
		setCurrentZoomValue(zoomValue);
		setIsDragging(false);
		setCurrentMouseOffet(initialMouseOffset);
	}
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '1920px',
				height: '1080px'
			}}>
				<img style={{
					width: '100%',
					height: '120px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '25px',
					left: '3px',
					width: '100%',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '45pt',
						textAlign: 'center',
						position: 'relative'
					}} className="title-font" tabIndex={0} id="VortexJobAidUI-ui-top">Vortex Job Aid</p>
				</div>
				<GeneralButton parameters= {{
					top: '9px',
					left: '1797px',
					ariaLbl: 'close',
					width: '112px',
					srcIdle: "./assets/images/general/buttons/button_close_window_main.png",
					srcHighlight: "./assets/images/general/buttons/button_close_window_down.png",
					srcDisabled: null,
					highlightOnHover: false,
					customImgStyle: {
						width: '100%',
						height: '100%'
					},
					customBttnStyle: {
						width: '100%',
						height: '100%'
					},
					onClicked: () => {
						props.parameters.onCloseClicked();
					}
				}}/>
				<div style={{
					width: '100%',
					height: '960px',
					position: 'absolute',
					top: '118px',
					left: '0',
					pointerEvents: 'all'
				}}>
					{/* Left container */}
					<div className='v-aid-container' style={{
						position: 'absolute',
						top: '2px',
						left: '0px',
						width: '530px',
						height: '960px',
						
					}}>
						{imageData.map((data: ImageData, indx: number) => {
							return (
								<div className='v-aid-container v-aid-container-single-image' style={{
									position: 'relative',
									top: '20px',
									left: '50%',
									width: '500px',
									minHeight: '350px',
									transform: 'translate(-50%, 0)'
								}} aria-label={data.altData} tabIndex={0} onKeyUp={mapDivEnterToClick} onClick={() => {
									setCurrentlySelectedImageIndx(indx);
								}}>
									<img src={data.img} style={{
										width: '100%'
									}} />
									{currentlySelectedImageIndx === indx ? <img src="./assets/images/vortex-job-aid/check_button_state.png" alt="" style={{
										width: '50px',
										position: 'absolute',
										right: '0',
										top: '0'
									}} /> : (null)}
								</div>
							);
						})};
						
					</div>

					{/* right container */}
					<div className='v-aid-container' style={{
						position: 'absolute',
						top: '2px',
						right: '0px',
						width: '1390px',
						height: '960px'
					}}>
						{/* selected image container */}
						<div className='v-aid-container' style={{
							position: 'absolute',
							top: '50px',
							left: '50%',
							width: '1260px',
							height: '740px',
							transform: 'translate(-50%, 0)',
							overflow: 'hidden'
						}} tabIndex={0} aria-label={imageData[currentlySelectedImageIndx].clickedAlt} onMouseDown={() => {
							var mouseMove = (event: any) => {
								//console.log(event)
								if(!mouseStartPos) {
									mouseStartPos = {
										top: event.clientY,
										left: event.clientX
									}
								}
								setCurrentMouseOffet({
									top: event.clientY - mouseStartPos.top,
									left: event.clientX - mouseStartPos.left
								});
							};

							var mouseUp =  (event: any) => {
								setIsDragging(false);
								window.removeEventListener('mouseup', mouseUp);
								window.removeEventListener('mousemove', mouseMove);
							};
							window.addEventListener('mouseup', mouseUp);
							window.addEventListener('mousemove', mouseMove);

							setIsDragging(true);
						}}>	
							<img src={imageData[currentlySelectedImageIndx].img} style={{
								width: imageData[currentlySelectedImageIndx].initialWidth,
								position: 'absolute',
								pointerEvents: 'none',
								top: '2px',
								left: '105px',
								transformOrigin: 'center center',
								transform: 'translate(' + currentMouseOffet.left + 'px, ' + currentMouseOffet.top + 'px) scale(' + currentZoomValue + ')'
							}} />
						</div>

						{/* buttons container */}
						<div className='v-aid-container' style={{
							position: 'absolute',
							top: '819px',
							left: '50%',
							transform: 'translate(-50%, 0)',
							padding: '5px',
							paddingBottom: '0px'
						}}>
							{/* back button container */}
							<GeneralButton parameters= {{
								top: '0',
								left: '0',
								ariaLbl: 'back',
								width: '102px',
								srcIdle: "./assets/images/vortex-job-aid/scroll_left_main.png",
								srcHighlight: "./assets/images/vortex-job-aid/scroll_left_down.png",
								srcDisabled: "./assets/images/vortex-job-aid/scroll_left_disable.png",
								highlightOnHover: false,
								customImgStyle: {
									width: '100%',
									height: '100%'
								},
								customBttnStyle: {
									width: '100%',
									height: '100%',
									padding: '0',
									margin: '0'
								},
								customContainerStyle: {
									position: 'relative',
									display: 'inline-block',
									padding: '0',
									margin: '0'
								},
								onClicked: () => {
									onNextOrBackClicked(currentlySelectedImageIndx-1);
								}
							}}/>

							{/* zoom in button container */}
							<GeneralButton parameters= {{
								top: '0',
								left: '0',
								ariaLbl: 'zoom in',
								width: '102px',
								isDisabled: currentZoomValue === maxZoomValue,
								srcIdle: "./assets/images/vortex-job-aid/zoom_in_main.png",
								srcHighlight: "./assets/images/vortex-job-aid/zoom_in_down.png",
								srcDisabled: "./assets/images/vortex-job-aid/zoom_in_disable.png",
								highlightOnHover: false,
								customImgStyle: {
									width: '100%',
									height: '100%'
								},
								customBttnStyle: {
									width: '100%',
									height: '100%',
									padding: '0',
									margin: '0'
								},
								customContainerStyle: {
									position: 'relative',
									display: 'inline-block',
									padding: '0',
									margin: '0'
								},
								onClicked: () => {
									onZoomClicked(currentZoomValue + zoomIncrement);
								}
							}}/>

							{/* zoom out button container */}
							<GeneralButton parameters= {{
								top: '0',
								left: '0',
								ariaLbl: 'zoom out',
								width: '102px',
								isDisabled: currentZoomValue === minZoomValue,
								srcIdle: "./assets/images/vortex-job-aid/zoom_out_main.png",
								srcHighlight: "./assets/images/vortex-job-aid/zoom_out_down.png",
								srcDisabled: "./assets/images/vortex-job-aid/zoom_out_disable.png",
								highlightOnHover: false,
								customImgStyle: {
									width: '100%',
									height: '100%'
								},
								customBttnStyle: {
									width: '100%',
									height: '100%',
									padding: '0',
									margin: '0'
								},
								customContainerStyle: {
									position: 'relative',
									display: 'inline-block',
									padding: '0',
									margin: '0'
								},
								onClicked: () => {
									onZoomClicked(currentZoomValue - zoomIncrement);
								}
							}}/>

							{/* next button container */}
							<GeneralButton parameters= {{
								top: '0',
								left: '0',
								ariaLbl: 'next',
								id: 'VortexJobAidUI-ui-bottom',
								width: '102px',
								srcIdle: "./assets/images/vortex-job-aid/scroll_left_main.png",
								srcHighlight: "./assets/images/vortex-job-aid/scroll_left_down.png",
								srcDisabled: "./assets/images/vortex-job-aid/scroll_left_disable.png",
								highlightOnHover: false,
								customImgStyle: {
									width: '100%',
									height: '100%',
									transform: 'scale(-1)'
								},
								customBttnStyle: {
									width: '100%',
									height: '100%',
									padding: '0',
									margin: '0'
								},
								customContainerStyle: {
									position: 'relative',
									display: 'inline-block',
									padding: '0',
									margin: '0'
								},
								onClicked: () => {
									onNextOrBackClicked(currentlySelectedImageIndx+1);
								}
							}}/>
						</div>
						
					</div>
				</div>
			</div>
		</div>
	);

};

export interface VortexJobAidUIConfig extends BaseConfig{
	onCloseClicked: () => void;
}

export default VortexJobAidUI;